//@flow
import React from "react";

import { Translate } from "@quantum/i18n";

import { connect } from "react-redux";

import SelecaoToleranciaInteiroNaoNegativo from "./SelecaoToleranciaInteiroNaoNegativo";
import {
  getToleranciaDFSelecionada,
  selecionarToleranciaDF,
  type ActionCreator,
} from "../../../../state";
import { VALOR_DEFAULT_TOLERANCIA_DEMONSTRACAO_FINANCEIRA } from "../../../../model";

type Props = {
  toleranciaDFSelecionada: number,
  selecionarToleranciaDF: ActionCreator,
};

function SelecaoToleranciaDF({
  toleranciaDFSelecionada,
  selecionarToleranciaDF,
}: Props) {
  function onChange(toleranciaDF) {
    selecionarToleranciaDF(
      toleranciaDF === null
        ? VALOR_DEFAULT_TOLERANCIA_DEMONSTRACAO_FINANCEIRA
        : toleranciaDF
    );
  }

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label ConfiguracaoMedida__label--block">
        <Translate>configuracaoRelatorio.tolerancia</Translate>{" "}
        <small className="ConfiguracaoMedida__hint">
          (<Translate>configuracaoRelatorio.demonstracaoFinanceira</Translate>)
        </small>
      </label>
      <SelecaoToleranciaInteiroNaoNegativo
        min={0}
        max={5}
        toleranciaSelecionada={toleranciaDFSelecionada}
        onChange={onChange}
      >
        <label className="ConfiguracaoMedida__label">
          <Translate>ConfiguracaoIndicador.trimestres</Translate>
        </label>
      </SelecaoToleranciaInteiroNaoNegativo>
    </div>
  );
}

export default connect(
  state => ({ toleranciaDFSelecionada: getToleranciaDFSelecionada(state) }),
  { selecionarToleranciaDF }
)(SelecaoToleranciaDF);
